// src/redux/uldSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchULDEDetails } from './thunks';

const initialState = {
  formData: [],
  status: 'idle',
  error: null,
};

const uldSlice = createSlice({
  name: 'uld',
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    updateFormData: (state, action) => {
      const { id, fieldName, value } = action.payload;
      state.formData = state.formData.map(stack => {
        if (stack.uld_number === id) {
          const updatedStack = { ...stack, [fieldName]: value };
          updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;
          return updatedStack;
        }
        return stack;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchULDEDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchULDEDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const { id, data } = action.payload;
        const { reg, asset_type } = data;

        state.formData = state.formData.map(stack => {
          if (stack.uld_number === id) {
            const updatedStack = { ...stack, reg, asset_type };
            updatedStack.uld_number = `${updatedStack.type_code || ''}${updatedStack.serial_number || ''}${updatedStack.owner_code || ''}`;

            const keyData = JSON.parse(localStorage.getItem('keyType')) || { ULD: {} };
            keyData.ULD = keyData.ULD.map(item => item.uld_number === id ? updatedStack : item);
            localStorage.setItem('keyType', JSON.stringify(keyData));

            return updatedStack;
          }
          return stack;
        });
      })
      .addCase(fetchULDEDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setFormData, updateFormData } = uldSlice.actions;

export default uldSlice.reducer;
